import { getOrderAccounting, GetOrderAccountingReturn } from 'graphql/ledger/queries';
import { useQuery, UseQueryOptions } from 'react-query';
import { AccountingFilter } from 'v2-types/order';

type Params = {
  orderId: string;
  filters?: { [key: string]: AccountingFilter };
  queryKey: string;
  queryConfig?: UseQueryOptions<GetOrderAccountingReturn, Error, GetOrderAccountingReturn, any>;
};

export const useGetOrderAccounting = ({ orderId, filters, queryConfig, queryKey }: Params) =>
  useQuery([{ orderId, filters }, queryKey], () => getOrderAccounting({ id: orderId, filters }), {
    ...queryConfig,
    enabled: !!orderId && queryConfig?.enabled !== false,
  });
